import { useLang } from "../../context/LangContext";
import { img, money } from "../../lib/api";

const Row = ({ label, value, testid, strong }) => (
  <div className={`flex justify-between py-1.5 ${strong ? "border-t border-sand pt-4 text-lg" : "text-sm"}`}>
    <span className={strong ? "font-display" : "text-ink/70"}>{label}</span>
    <span data-testid={testid}>{value}</span>
  </div>
);

export const OrderSummary = ({ quote, items, children }) => {
  const { t, L } = useLang();
  const lines = quote?.items?.length ? quote.items : items;
  const sar = (n) => `${money(n)} ${t("sar")}`;
  return (
    <aside data-testid="order-summary" className="bg-sand-light/70 p-6 sm:p-8">
      <h3 className="mb-6 font-display text-2xl">{t("order_summary")}</h3>
      <div className="space-y-4">
        {lines.map((i) => (
          <div key={`${i.product_id}${i.size}${i.color}`} className="flex gap-4">
            <div className="relative">
              <img src={img(i.image)} alt="" className="h-20 w-16 object-cover" />
              <span className="absolute -end-2 -top-2 grid h-5 w-5 place-items-center rounded-full bg-ink text-[10px] text-ivory">{i.qty}</span>
            </div>
            <div className="flex-1 text-sm">
              <p>{L(i, "name")}</p>
              <p className="mt-1 text-xs text-sand-dark">{[i.size, i.color].filter(Boolean).join(" / ")}</p>
            </div>
            <span className="text-sm">{sar(i.line_total ?? i.price * i.qty)}</span>
          </div>
        ))}
      </div>
      {children}
      {quote && (
        <div className="mt-6 border-t border-sand pt-4">
          <Row label={t("subtotal")} value={sar(quote.subtotal)} testid="summary-subtotal" />
          {quote.discount > 0 && <Row label={`${t("discount")} (${quote.coupon_code})`} value={`- ${sar(quote.discount)}`} testid="summary-discount" />}
          <Row label={t("shipping")} value={quote.shipping === 0 ? t("free") : sar(quote.shipping)} testid="summary-shipping" />
          {quote.cod_fee > 0 && <Row label={t("cod_fee")} value={sar(quote.cod_fee)} />}
          {quote.tax > 0 && <Row label={quote.tax_inclusive ? t("vat") : t("vat_ex")} value={sar(quote.tax)} testid="summary-tax" />}
          <Row label={t("total")} value={sar(quote.total)} testid="summary-total" strong />
          {quote.zone && <p className="mt-3 text-xs text-sand-dark" data-testid="summary-delivery-estimate">{t("delivery_est", { a: quote.zone.days_min, b: quote.zone.days_max })}</p>}
        </div>
      )}
    </aside>
  );
};
